import { render, staticRenderFns } from "./adminupdate.vue?vue&type=template&id=586f047e&scoped=true&"
import script from "./adminupdate.vue?vue&type=script&lang=js&"
export * from "./adminupdate.vue?vue&type=script&lang=js&"
import style0 from "./adminupdate.vue?vue&type=style&index=0&id=586f047e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586f047e",
  null
  
)

export default component.exports